<template>
  <img src="../../assets/image/sblogo.png" class="logo" alt="ソフトバンク" />
</template>

<style>
.logo {
  height: 20px;
  margin-right: 20px;
  margin-left: 2px;
}
</style>
